import { navigate } from 'gatsby'
import { ActionLink } from 'app/_shared'

export default ({finish, mode, children}) => {
  return (
    <div>
      {children}
      <ActionLink appearance="arrow" onClick={() => {
        finish();
        if (mode !== 'app') {
          navigate('/my');
        }
      }}>
        Continue
      </ActionLink>
    </div>
  )
}
